import { SbBlokData } from '@cinch-nx/data-storyblok'
import { AiSearchInput } from '@cinch-nx/feature-ai-search'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import { StoryblokRendererV2 as StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { useResponsiveEnvironment } from '@retail-common/util-hooks'
import React, { useMemo } from 'react'
import { MarketingCarousel } from '../marketing-carousel'
import styles from './ai-search-section.module.css'

export interface AISearchSectionProps {
  heading: string
  searchBoxPlaceholders: SbBlokData[]
  buttons: SbBlokData[]
  marketingCarousel: SbBlokData[]
}

const marketingCarouselComponents = {
  LoopingCarousel: MarketingCarousel,
}

export const AISearchSection: React.FC<AISearchSectionProps> = ({
  heading,
  searchBoxPlaceholders,
  buttons,
  marketingCarousel,
}) => {
  const { isMobile } = useResponsiveEnvironment()

  const placeholders = useMemo(
    () =>
      searchBoxPlaceholders
        .map((placeholder) => {
          const text = (placeholder as SbBlokData & { text?: unknown }).text
          return typeof text === 'string' ? text.trim() : ''
        })
        .filter(Boolean),
    [searchBoxPlaceholders],
  )

  return (
    <section className={styles.container}>
      <div className={styles.aiSearchBox}>
        <h2 className={styles.heading}>{heading}</h2>
        <div className={styles.aiSearchInput}>
          <AiSearchInput
            placeholders={placeholders}
            showSubmitButton={!isMobile}
          />
        </div>
        {buttons.length > 0 && (
          <div className={styles.ctaButtons}>
            {buttons.map((button, index) => (
              <StoryblokRenderer
                key={`ai-search-box-button-${index}`}
                block={button}
                components={globalStoryblokComponents}
              />
            ))}
          </div>
        )}
      </div>
      {marketingCarousel.length > 0 && (
        <div className={styles.marketingCarouselWrapper}>
          <StoryblokRenderer
            block={marketingCarousel[0]}
            components={marketingCarouselComponents}
          />
        </div>
      )}
    </section>
  )
}
